<template>
  <el-dialog
    v-bind="$attrs"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
    @closed="closed"
    class="base-dialog"
  >
    <slot></slot>
    <div v-if="!noFooter" slot="footer" class="dialog-footer">
      <slot name="footer_before"></slot>
      <v-button
        v-if="!noCancel"
        :type="cancelType"
        size="small"
        :right="!noCancel ? 12 : 0"
        @click="close"
        :name="cancelText"
      ></v-button>
      <slot name="footer_middle"></slot>
      <v-button
        v-if="!noConfirm"
        type="normal-bg"
        size="small"
        :class="{ disabled }"
        @click="$emit('confirm')"
        :name="confirmText"
      ></v-button>
      <slot name="footer"></slot>
    </div>
  </el-dialog>
</template>
<script>
import i18n from '@/utils/i18n';
export default {
  name: 'QzDialog',
  inheritAttrs: false,
  props: {
    cancelType: {
      type: String,
      default: 'normal',
    },
    cancelText: {
      type: String,
      default: i18n.t('common.cancel'),
    },
    noCancel: {
      type: Boolean,
      default: false,
    },
    confirmText: {
      type: String,
      default: i18n.t('common.ok2'),
    },
    noConfirm: {
      type: Boolean,
      default: false,
    },
    noFooter: {
      type: Boolean,
      default: false,
    },
    disabled: {
      // 是否禁用确认按钮
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit(`update:visible`, false);
    },
    closed() {
      this.$emit('closed');
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .v-button {
    &.disabled {
      background-color: #f4f5f9 !important;
      color: #bdbdc3;
      border-color: #f4f5f9 !important;
      pointer-events: none;
    }
  }
}
</style>
<style lang="scss">
.base-dialog {
  .el-input__inner,
  .el-radio__input.is-checked + .el-radio__label,
  .el-radio__label {
    line-height: 38px;
  }
  .el-input--small .el-input__inner,
  .el-input--suffix .el-input__inner {
    height: 38px;
  }
  .el-form--label-top .el-form-item__label {
    line-height: 38px;
    font-weight: normal;
  }
  .el-form-item__content {
    font-weight: bold;
    font-size: 16px;
  }
  .el-input .el-input__icon {
    line-height: 38px;
  }
}
</style>
